var _path, _path2, _path3, _path4, _g, _path5, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_48913)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_580_48913)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4296 54.7728L8.57206 54.7728C4.51841 54.7728 1.22808 51.4825 1.22808 47.4289L1.22808 8.57127C1.22808 4.51801 4.51803 1.23833 8.57206 1.23833L47.4296 1.23833C51.4833 1.23833 54.7626 4.51762 54.7626 8.57127L54.7626 47.4289C54.7626 51.4829 51.4829 54.7728 47.4296 54.7728Z",
    fill: "url(#paint0_linear_580_48913)",
    stroke: "#48BDFF",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 8.5712L56 47.4288C56 52.1562 52.1562 56 47.4288 56L8.5712 56C3.84379 56 0 52.1562 0 47.4288L0 8.5712C0 3.84379 3.84379 0 8.5712 0L47.4288 0C52.1562 0 56 3.84379 56 8.5712ZM8.5712 1.03826C4.4071 1.03826 1.02722 4.4071 1.02722 8.5712L1.02722 47.4288C1.02722 51.5929 4.4071 54.9728 8.5712 54.9728L47.4288 54.9728C51.5929 54.9728 54.9617 51.5929 54.9617 47.4288L54.9617 8.5712C54.9617 4.4071 51.5929 1.03826 47.4288 1.03826L8.5712 1.03826Z",
    fill: "url(#paint1_linear_580_48913)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.3972 49.5936L10.6043 49.5936C8.28475 49.5936 6.396 47.7159 6.396 45.3964L6.396 10.6035C6.396 8.28396 8.28475 6.40625 10.6043 6.40625L45.3972 6.40625C47.7167 6.40625 49.5944 8.28396 49.5944 10.6035L49.5944 45.3964C49.5944 47.7159 47.7167 49.5936 45.3972 49.5936Z",
    fill: "url(#paint2_linear_580_48913)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.4296 1.03833L8.57206 1.03833C4.40796 1.03833 1.02808 4.40717 1.02808 8.57127V9.34445C1.02808 5.18034 4.40796 1.80046 8.57206 1.80046L47.4296 1.80046C51.5938 1.80046 54.9626 5.18034 54.9626 9.34445V8.57127C54.9626 4.40717 51.5938 1.03833 47.4296 1.03833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M47.4296 54.1001L8.57206 54.1001C4.40796 54.1001 1.02808 50.7312 1.02808 46.5671V47.4287C1.02808 51.5928 4.40796 54.9727 8.57206 54.9727L47.4296 54.9727C51.5938 54.9727 54.9626 51.5928 54.9626 47.4287V46.5671C54.9626 50.7312 51.5938 54.1001 47.4296 54.1001Z",
    fill: "#00050E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_580_48913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.29 41.7512L19.29 20.7512H27.18C33.12 20.8112 37.26 25.2812 37.26 31.2512C37.26 37.2212 33.12 41.6912 27.18 41.7512H19.29ZM26.22 25.7912V36.7112C31.5 36.4412 31.5 26.0612 26.22 25.7912Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3323 16.7197V17.751H42.0901V16.8647L44.636 14.0879C44.9153 13.7728 45.1355 13.5007 45.2966 13.2715C45.4578 13.0423 45.5706 12.8364 45.635 12.6538C45.703 12.4676 45.7371 12.2868 45.7371 12.1113C45.7371 11.8643 45.6905 11.6476 45.5974 11.4614C45.5079 11.2716 45.3754 11.123 45.2 11.0156C45.0245 10.9046 44.8114 10.8491 44.5608 10.8491C44.2708 10.8491 44.0273 10.9118 43.8303 11.0371C43.6334 11.1624 43.4848 11.3361 43.3845 11.5581C43.2843 11.7765 43.2341 12.0272 43.2341 12.3101H41.9397C41.9397 11.8553 42.0435 11.4399 42.2512 11.064C42.4589 10.6844 42.7597 10.3836 43.1536 10.1616C43.5474 9.93604 44.0219 9.82324 44.5769 9.82324C45.0997 9.82324 45.5437 9.91097 45.9089 10.0864C46.2742 10.2619 46.5517 10.5107 46.7415 10.833C46.9348 11.1553 47.0315 11.5366 47.0315 11.9771C47.0315 12.2205 46.9921 12.4622 46.9133 12.7021C46.8346 12.9421 46.7218 13.182 46.575 13.4219C46.4317 13.6582 46.2616 13.8963 46.0647 14.1362C45.8678 14.3726 45.6511 14.6125 45.4148 14.856L43.7229 16.7197H47.3323Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.1
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    r: 34,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_580_48913",
    x: -15,
    y: -11,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.721569 0 0 0 0 0.905882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_48913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_48913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_580_48913",
    x: 4.29004,
    y: 5.75122,
    width: 47.97,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_580_48913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_580_48913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_48913",
    x1: -5.49951,
    y1: 19.5383,
    x2: 65.0005,
    y2: 45.0383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_580_48913",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A80F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C46B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_580_48913",
    x1: 34.6256,
    y1: -43.1315,
    x2: 51.5214,
    y2: 12.8137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_48913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.122254c5f287589d7c313dae2ded72e3.svg";
export { ForwardRef as ReactComponent };